import React from "react";
import { Link } from "react-router-dom";
import { formatMoney } from "accounting-js";
import IconEdit from "./IconEdit";
import IconDelete from "./IconDelete";
import style from "./HardwareMain.module.css";
import HardwareExtraOptions from "./HardwareExtraOptions";
import { connect } from "react-redux";
import IconSuccess from "./IconSuccess";
import IconWarning from "./IconWarning";
import { Badge, Button, Table } from "react-bootstrap";
import HardwareBundleOptions from "./HardwareBundleOptions";
import QuantityInput from "./QuantityInput";
import { deleteQuoteItem, setQuoteItemQty } from "../redux/actions";
import Image from "./shared/Image";

function HardwareMain({
  item,
  itemValidationMap,
  setQuoteItemQty,
  deleteQuoteItem,
  backendValidationMessages
}) {
  const productUrl = `/product/${item.sku}`;
  const isAvailable = !itemValidationMap.some(
    validationItem =>
      Number(validationItem.productId) === Number(item.productId)
  );

  const hardwareOptions = item.options
    ? item.options
        .map(o => ({
          ...o,
          selections: o.selections.filter(s => !s.isSoftware)
        }))
        .filter(o => o.selections.length)
    : [];

  const softwareOptions = item.options
    ? item.options
        .map(o => ({
          ...o,
          selections: o.selections.filter(s => s.isSoftware)
        }))
        .filter(o => o.selections.length)
    : [];

    const backendValidationErrors = backendValidationMessages.filter(err => err.id === item.key && err.selectionIds.length === 0)

  return (
    <Table className={style.root} variant="sm">
      <thead>
        <tr>
          <th className={style.image}>Product</th>
          <th />
          <th className={style.backorder} />
          <th className={style.availability}>Availability</th>
          <th className={style.msp}>Minimum Sell Price (MSP)</th>
          <th className={style.targetPrice}>Target Price</th>
          <th className={style.qty}>Quantity</th>
          <th className={style.lineTotal}>Target Line Total</th>
          <th className={style.actions}>Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr key={item.key}>
          <td>
            <Link to={productUrl}>
              <Image src={item.image} alt={item.name} width="50" height="50" />
            </Link>
          </td>

          <td>
            <h3 className={style.productName}>
              <Link to={productUrl}>
                {item.name}
                {item.excludeFromMarginSplit && (
                  <Badge variant="danger">Excluded from margin splitting</Badge>
                )}
              </Link>
            </h3>
          </td>
          <td></td>
          <td className="text-center">
            {isAvailable ? <IconSuccess /> : <IconWarning />}
          </td>

          <td>{formatMoney(Number(item.price))}</td>

          <td>{formatMoney(Number(item.targetPrice))}</td>

          <td>
            <QuantityInput
              type="number"
              className="form-control"
              value={item.qty}
              onConfirm={e => setQuoteItemQty(item, e.target.value)}
            />
          </td>

          <td>{formatMoney(item.targetPrice * item.qty)}</td>

          <td>
            <Button
              as={Link}
              to={`${productUrl}?quoteItemKey=${item.key}`}
              variant="link"
            >
              <IconEdit />
            </Button>
            <Button
              variant="link"
              onClick={e => {
                e.preventDefault();
                deleteQuoteItem({ key: item.key });
              }}
            >
              <IconDelete />
            </Button>
          </td>
        </tr>
        {backendValidationErrors.map((err, index) =>
          <tr key={`${err.id}-${index}`}>
            <td className="alert-danger" colSpan="9">{err.errorMessage}</td>
          </tr>
          )
        }

        {hardwareOptions.length ? (
          <>
            {softwareOptions.length ? (
              <tr className="table-secondary">
                <td />
                <td colSpan="7">
                  <h4>Hardware in Bundle</h4>
                </td>
              </tr>
            ) : null}
            <HardwareBundleOptions
              parentQty={item.qty}
              options={hardwareOptions}
              itemKey={item.key}
            />
          </>
        ) : null}

        {softwareOptions.length ? (
          <>
            {hardwareOptions.length ? (
              <tr className="table-secondary">
                <td />
                <td colSpan="7">
                  <h4>Software in Bundle</h4>
                </td>
              </tr>
            ) : null}
            <HardwareBundleOptions
              parentQty={item.qty}
              options={softwareOptions}
              itemKey={item.key}
            />
          </>
        ) : null}

        <tr>
          <td />
          <td colSpan="7">
            <HardwareExtraOptions item={item} />
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

export default connect(
  state => ({
    itemValidationMap: state.quote.itemValidationMap,
    backendValidationMessages: state.quote.backendValidationMessages
  }),
  {
    deleteQuoteItem,
    setQuoteItemQty
  }
)(HardwareMain);
